<template>
    <div>
        <h4>Editor</h4>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="name">
                        Name:
                    </label>
                    <custom-input id="name" :option="template" :objKey="'description'"
                                  @changed="template.description = $event; groupHasChanged = true" >
                    </custom-input>
                </div>
            
            </div>
            <div class="col-12">
                Custom asset:
                <file-input class="d-block"
                            :multiple="false"
                            @change="handleFileInput"/>
                <p v-if="linkToCopy">
                    Copy this link to background-image:
                    <strong>{{linkToCopy}}</strong>
                </p>
            </div>
            <div class="col-12">
                <ul v-for="(value, propertyName, index) in template.style"
                    :key="'style_' + propertyName">
                    <object-value :key="propertyName"
                                  :propertyName="propertyName"
                                  :objValue="value"
                                  :parentPropName="'style'"
                                  :path="propertyName"
                                  :isTemplateGroup="true"
                                  @deleteProp="handleStyleDeletion"
                                  @updatedValue="updateStyleInTemplate"/>
                </ul>
                <css-props :selectedProp="selectedProp"
                           :value="selectedPropValue"
                           :mode="'add'"
                           :newProperty="true"
                           :isTemplate="true"
                           @addStyle="addStyle"
                           @selectedProperty="selectedProp = $event"
                           @newValue="selectedPropValue = $event.value"></css-props>
                <div class="layout-picker mt-4">
                    <label for="layoutpicker">Choose template groups</label>
                    <multiselect v-model="template.groups"
                                 :deselect-label="$t('UI.cantRemove')"
                                 track-by="id"
                                 :multiple="true"
                                 label="label"
                                 :max-height="600"
                                 @input="$emit('update:template', template)"
                                 :hide-selected="true"
                                 placeholder="Select template groups"
                                 id="layoutpicker"
                                 :preserve-search="true"
                                 :options="templateGroups"
                                 :searchable="true"
                                 :allow-empty="true"></multiselect>
                </div>
            </div>
        </div>
        <button :class="['btn', mode === 'addition' ? 'btn-primary' : 'btn-cph-primary-outline']"
                @click="handleSave(mode)">
            {{mode === 'addition' ? $t('UI.add') : $t('UI.save')}}
        </button>
    </div>
</template>

<script type="text/babel">
import CustomInput from '../CustomInput';
import CssProps from '../Workspace/ValueEditor/CssProp/CssProp.vue';
import ObjectValue from '../Workspace/ValueEditor/ObjectValue';
import FileInput from '../../../Shared/FileInput/FileInput';
import { mapGetters, mapMutations, mapActions } from 'vuex';
export default {
    name: 'TemplatesEditor',
    data () {
        return {
            groupHasChanged: false,
            selectedPropValue: '',
            linkToCopy: null,
            selectedProp: {
                value: ''
            }
        };
    },
    components: {
        CustomInput,
        FileInput,
        CssProps,
        ObjectValue
    },
    props: {
        template: {
            type: Object
        },
        mode: {
            type: String
        }
    },
    computed: {
        ...mapGetters({
            templates : 'getTemplates',
            templateGroups :'getTemplateGroups'
        }),
        templateStyle () {
            return this.template.style;
        }
    },
    methods: {
        ...mapActions(['']),
        ...mapMutations(['']),
        handleFileInput (files) {
            this.linkToCopy = `url('http://coldstorage:1337/store/${files[0].new}?web')`;
            
        },
        addStyle (newValue) {
            this.$vueSet(this.template, `style.${newValue.prop}`, newValue.value);
            this.selectedPropValue = '';
            this.selectedProp = {
                value: ''
            };
        },
        handleSave (mode) {
            const isAdding = mode === 'addition';
            isAdding ? this.$emit('add') : this.$emit('save');
            this.$store.commit('addAlert', {
                title: 'Successfuly ',
                type: 'success',
                body: isAdding ? 'added a template' : 'saved a template'
            });
        },
        updateStyleInTemplate ({prop, value}) {
            this.$set(this.template.style, `${prop}`, value);
            this.$emit('update:template', this.template);
        },
        handleStyleDeletion (propertyName) {
            this.$emit('deleteProperty', propertyName);
        }
    }
};

</script>
